import React from "react";
import { graphql, compose, withApollo } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment-timezone";
import Button from "./Button";
import PatientSelect from "./PatientSelect";

class SlotModal extends React.Component {
  constructor(props) {
    super(props);
    let pid = null;
    if (this.props.event.patient !== null) {
      pid = this.props.event.patient.id;
    }
    this.state = {
      name: "",
      patient: {
        ville: "",
        portable: "",
        email: "",
        telephone: "",
        adresse: "",
        codepostal: ""
      },
      confirm: false,
      loading: false,
      note: this.props.event.comment,
      oldNote: this.props.event.comment,
      noteChanged: false,
      patientIdChanged: false,
      color: this.props.event.color,
      oldPatientId: pid,
      patientId: pid,
      showPatientsSelect: false,
      noteChangedError: false,
      patientIdChangedError: false,
      colorSaved: false,
      colorError: false
    };
  }

  handleNote = event => {
    let note = event.target.value;
    if (note === null) {
      note = "";
    }
    this.setState(
      {
        note,
        noteChanged: false
      },
      () => this.saveSlot("comment")
    );
    /*  if (note !== this.state.oldNote) {
      noteChanged = true;

    } else {
      noteChanged = false;
    }*/
  };
  componentWillReceiveProps(newProps) {
    if (!newProps.getPatientById.loading) {
      let p = newProps.getPatientById.Patient;
      if (p === null) {
        p = {
          ville: "",
          portable: "",
          email: "",
          telephone: "",
          adresse: "",
          codepostal: ""
        };
      }
      if (this.state.patientId === this.state.oldPatientId) {
        this.setState({
          patient: p
        });
      }
    }
  }

  changePatient = async id => {
    const result = await this.props.client.query({
      query: PATIENTS_SEARCH_BY_ID,
      variables: { patientId: id }
    });
    if (this.state.patientId !== id) {
      this.setState(
        {
          patientId: id,
          patient: result.data.Patient,
          patientIdChanged: false
        },
        () => this.saveSlot("patient")
      );
    } else {
      this.setState({
        patientId: id,
        patient: result.data.Patient,
        patientIdChanged: false
      });
    }
  };
  onColorChange = color => {
    let ncolor = "#00893D";
    if (color) {
      //  this.setState({ color: color.color });
      ncolor = color.color;
    } /* else {
      this.setState({ color: "#00893D" });
    }*/
    this.saveColor(ncolor);
  };

  saveColor = async color => {
    const id = this.props.event.slotId;

    await this.props
      .updateColorSlotMutation({
        variables: { id, color }
      })
      .then(() => {
        this.setState({
          color: color,
          colorSaved: true,
          colorError: false
        });
        //this.props.toggleModal();
      })
      .catch(e => {
        console.error("update slot color", e);
        this.setState({
          colorSaved: false,
          colorError: true
        });
      });
  };

  saveSlot = async whatChanged => {
    const id = this.props.event.slotId;
    const patientId = this.state.patientId;
    const comment = this.state.note;
    let color = this.state.color;
    if (color === "#00893D") {
      color = null;
    }

    await this.props
      .updateSlotMutation({
        variables: { id, comment, patientId, color }
      })
      .then(() => {
        if (whatChanged === "comment") {
          this.setState({
            noteChanged: true
          });
        }
        if (whatChanged === "patient") {
          this.setState({
            patientIdChanged: true
          });
        }
        //throw new Error();

        //    this.props.toggleModal();
      })
      .catch(e => {
        if (whatChanged === "comment") {
          this.setState({
            noteChanged: false,
            noteChangedError: true
          });
        }
        if (whatChanged === "patient") {
          this.setState({
            patientIdChanged: false,
            patientIdChangedError: true
          });
        }
        console.error("update slot", e);
      });
  };

  toggleConfirm = () => {
    this.setState({ confirm: !this.state.confirm });
  };
  handleCancel = async () => {
    const id = this.props.event.slotId;
    this.setState({
      loading: true
    });
    let status = "REMOVED";
    let canceledBy = this.props.userName;
    this.props
      .updateSlotCancel({
        variables: { id, status, canceledBy }
      })
      .then(() => {
        this.setState(
          { loading: false, deleted: true },
          this.props.toggleModal
        );
      })
      .catch(e => {
        this.setState({ loading: false, error: true });
        console.error("delete slot", e);
      });
  };

  showPatientsSelect = () => {
    this.setState({ showPatientsSelect: true });
  };

  render() {
    let note = this.state.note;
    if (note === null) {
      note = "";
    }
    let patientId = this.props.event.patient ? this.props.event.patient.id : "";
    let nom = this.props.event.patient
      ? this.props.event.patient.nom
      : "Patient";
    let prenom = this.props.event.patient
      ? this.props.event.patient.prenom
      : "effacé";
    let matricule = this.props.event.patient
      ? this.props.event.patient.matricule
      : "";
    let fclass = "tag";
    let color = this.state.color;
    if (!color || color.length === 0 || color.toLowerCase() === "#00893d") {
      color = "#00893d"; //"whitesmoke";
      fclass = "tag selected-color";
    }
    let colors = [];
    colors.push(
      <span
        className={fclass}
        style={{
          width: "30px",
          height: "30px",
          marginRight: "10px",
          cursor: "pointer",
          backgroundColor: "#00893d",
          marginLeft: "5px"
        }}
        key={"00893d"}
        onClick={() => this.onColorChange(null)}
      />
    );
    /**/
    if (!this.props.getColors.loading) {
      let ncolors = this.props.getColors.allColors.map(color2 => {
        let cssClass = color2.color === color ? "tag selected-color" : "tag";
        return (
          <span
            className={cssClass}
            style={{
              width: "30px",
              height: "30px",
              cursor: "pointer",
              marginRight: "10px",
              marginTop: "5px",
              backgroundColor: color2.color
            }}
            key={color2.id}
            onClick={() => this.onColorChange(color2)}
          />
        );
      });
      colors = [...colors, ...ncolors];
    }
    let addressLink = "";
    if (this.state.patient) {
      if (
        navigator.platform.indexOf("iPhone") !== -1 ||
        navigator.platform.indexOf("iPod") !== -1 ||
        navigator.platform.indexOf("iPad") !== -1
      ) {
        let href = `maps://maps.google.com/maps?daddr=${this.state.patient
          .adresse}, ${this.state.patient.codepostal}, ${this.state.patient
          .ville}&amp;ll=`;
        addressLink = (
          <a href={href}>
            {this.state.patient.adresse}, {this.state.patient.codepostal},{" "}
            {this.state.patient.ville}
          </a>
        );
      } else {
        let href = `https://maps.google.com/maps?daddr=${this.state.patient
          .adresse}, ${this.state.patient.codepostal}, ${this.state.patient
          .ville}&amp;ll=`;
        addressLink = (
          <a href={href} target="_blank">
            {this.state.patient.adresse}, {this.state.patient.codepostal},{" "}
            {this.state.patient.ville}
          </a>
        );
      }
    }
    let emailLink = "";

    if (this.state.patient && this.state.patient.email) {
      emailLink = (
        <a href={`mailto:${this.state.patient.email}`}>
          {this.state.patient.email}
        </a>
      );
    }

    return (
      <div>
        <div>
          {this.props.getColors.loading ? (
            <div
              style={{
                height: "40px",
                textAlign: "left",
                display: "inline-block"
              }}
            />
          ) : (
            <div
              style={{
                height: "40px",
                textAlign: "left",
                display: "inline-block"
              }}
            >
              {colors}
              {this.state.colorError ? (
                <span
                  className="is-pulled-right tag is-danger"
                  style={{ marginTop: "8px" }}
                >
                  erreur!
                </span>
              ) : null}
              {this.state.colorSaved ? (
                <span
                  className="blink tag is-success"
                  style={{ marginTop: "8px" }}
                >
                  sauvegardé!
                </span>
              ) : null}
            </div>
          )}
          {moment(this.props.event.start).isAfter(moment(), "minutes") ? (
            <Button
              color="red"
              text="Annuler rdv"
              onClick={this.toggleConfirm}
              style={{
                float: "right",
                display: "inline-block",
                padding: "0.68rem"
              }}
            />
          ) : null}
        </div>

        <section className="">
          {this.state.confirm ? (
            <div className="modal-slot-overlay">
              <div className="modal-slot-overlay-content">
                <h1 className="title">Êtes-vous sûr?</h1>
                <p>
                  <Button
                    style={{
                      width: "100px"
                    }}
                    text="Retour"
                    onClick={this.toggleConfirm}
                  />
                  <Button
                    color="red"
                    text="Oui!"
                    onClick={this.handleCancel}
                    style={{
                      width: "100px"
                    }}
                  />
                </p>
              </div>
            </div>
          ) : null}

          <hr
            style={{
              margin: "10px 0px 10px 0px"
            }}
          />
          <div className="columns">
            <div className="column">
              <label className="label">Type de rendez-vous:</label>
              <div className="control">{this.props.event.slotType.name}</div>
            </div>
            <div className="column">
              <label className="label">Heure:</label>
              <div className="control">
                {moment(this.props.event.start).format("DD/MM/YYYY")} à{" "}
                {moment(this.props.event.start).format("HH:mm")}-{moment(this.props.event.end).format("HH:mm")}{" "}
                <span className="tag is-light">
                  ajouté le{" "}
                  {moment(this.props.event.createdAt).format(
                    "DD/MM/YYYY [à] HH:mm"
                  )}
                  {this.props.event.takenBy ? (
                    ` par ${this.props.event.takenBy}`
                  ) : (
                    ""
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <label className="label">
                Info rendez-vous:
                {this.state.noteChanged ? (
                  <span className="blink tag is-success">sauvegardé!</span>
                ) : null}
                {this.state.noteChangedError ? (
                  <span className="is-pulled-right tag is-danger">erreur!</span>
                ) : null}
              </label>
              <div className="control">
                <textarea
                  className="textarea"
                  cols="5"
                  rows="2"
                  value={note}
                  onChange={this.handleNote}
                />
              </div>
            </div>
          </div>
          <hr
            style={{
              margin: "5px 0px 10px 0px"
            }}
          />
          <div className="columns">
            <div className="column">
              <label className="label">
                Patient:
                {this.state.patientIdChanged ? (
                  <span className="blink tag is-success">sauvegardé!</span>
                ) : null}
                {this.state.patientIdChangedError ? (
                  <span className="is-pulled-right tag is-danger">erreur!</span>
                ) : null}
              </label>
              <div className="control">
                {this.state.showPatientsSelect ? (
                  <PatientSelect
                    patientId={patientId}
                    slotId={this.props.event.slotId}
                    changePatient={this.changePatient}
                  />
                ) : (
                  <span
                    onClick={this.showPatientsSelect}
                    style={{
                      cursor: "pointer"
                    }}
                  >
                    {nom} {prenom} ({matricule})
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="columns">
            <div className="column">
              <label className="label">Numéro de portable</label>
              <div className="control">
                {this.state.patient &&
                this.state.patient.portable &&
                this.state.patient.portable.length > 0 ? (
                  <a href={`tel:${this.state.patient.portable}`}>
                    {this.state.patient.portable}
                  </a>
                ) : null}
              </div>
            </div>
            <div className="column">
              <label className="label">Numéro de téléphone fixe</label>
              <div className="control">
                {this.state.patient &&
                this.state.patient.telephone &&
                this.state.patient.telephone.length > 0 ? (
                  <a href={`tel:${this.state.patient.telephone}`}>
                    {this.state.patient.telephone}
                  </a>
                ) : null}
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <label className="label">Adresse</label>
              <div className="control">{addressLink}</div>
            </div>
            <div className="column">
              <label className="label">Email</label>
              <div className="control">{emailLink}</div>
            </div>
          </div>
        </section>

        {/*  <footer className="modal-card-foot">

          <Button text="Retour" onClick={this.props.toggleModal} />

          <Button
            disabled={!this.state.noteChanged && !this.state.patientIdChanged}
            color="#00893D"
            text="Sauvegarder"
            onClick={this.saveSlot}
          />
        </footer>*/}
      </div>
    );
  }
}

const DELETE_RDV_MUTATION = gql`
  mutation deleteSlotMutation($id: ID!) {
    deleteSlot(id: $id) {
      id
    }
  }
`;
const UPDATE_SLOT_CANCEL = gql`
  mutation updateSlotCancel(
    $id: ID!
    $status: SlotStatus!
    $canceledBy: String!
  ) {
    updateSlot(id: $id, status: $status, canceledBy: $canceledBy) {
      id
    }
  }
`;
const UPDATE_SLOT_MUTATION = gql`
  mutation UpdateSlotMutation(
    $id: ID!
    $comment: String
    $patientId: ID
    $color: String
  ) {
    updateSlot(
      id: $id
      comment: $comment
      patientId: $patientId
      color: $color
    ) {
      id
    }
  }
`;
const UPDATE_COLOR_SLOT_MUTATION = gql`
  mutation UpdateColorSlotMutation($id: ID!, $color: String) {
    updateSlot(id: $id, color: $color) {
      id
    }
  }
`;
const GET_COLORS_QUERY = gql`
  query {
    allColors {
      id
      color
    }
  }
`;
const PATIENTS_SEARCH_BY_ID = gql`
  query getPatientById($patientId: ID!) {
    Patient(id: $patientId) {
      id
      nom
      prenom
      matricule
      telephone
      portable
      email
      adresse
      codepostal
      ville
    }
  }
`;
export default compose(
  graphql(GET_COLORS_QUERY, {
    name: "getColors"
  }),
  graphql(DELETE_RDV_MUTATION, {
    name: "deleteSlotMutation"
  }),
  graphql(UPDATE_SLOT_CANCEL, {
    name: "updateSlotCancel"
  }),
  graphql(UPDATE_SLOT_MUTATION, {
    name: "updateSlotMutation"
  }),
  graphql(UPDATE_COLOR_SLOT_MUTATION, {
    name: "updateColorSlotMutation"
  }),
  graphql(PATIENTS_SEARCH_BY_ID, {
    name: "getPatientById",
    options: ({ patientId }) => ({ variables: { patientId } }),
    skip: ({ patientId }) => patientId === null
  }),
  withApollo
)(SlotModal);



// WEBPACK FOOTER //
// ./src/components/utilities/SlotModal.js